import React from "react";
import { connect } from "react-redux";
import ContentBackground from "./ContentBackground";
import GateForm from "../ContactFormNew/GateForm";
import getAction from "../../../services/actionDictionary";
import { createMarkup } from "../../../services/checkAndCreateMarkup";
import hasGatedFalseURLParam from "../../../services/paramChecker";
import eloquaActions from "../../../store/redux/form-submitted/form-submitted-actions";
import formEntryActions from "../../../store/redux/form-entry/form-entry-actions";
import { domainType, verticalType } from "../../../types";
import "../../../styles/content.less";

class ContentTemplate extends React.Component {
    state = {
        isMobile: false
    };

    componentDidMount() {
        const { hasSubmitted, item } = this.props;
        const { isGated } = this.state;
        if (JSON.parse(item.data.is_gated) && !hasGatedFalseURLParam()) {
            this.setState({ isGated: true });
        }
        if (hasSubmitted && isGated) {
            this.processAndSubmit();
        }
        window.addEventListener("resize", this.resize);
        this.resize();
    }

    componentDidUpdate(prevProps) {
        const { hasSubmitted, item } = this.props;
        const isGated = JSON.parse(item.data.is_gated);
        const isNotSamePage = window.location.pathname !== prevProps.location.pathname;
        if (hasSubmitted && isGated && isNotSamePage) {
            this.processAndSubmit();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize = () => {
        this.setState({
            isMobile: document.body.getBoundingClientRect().width <= 768
        });
    };

    processAndSubmit = () => {
        const { domain, vertical, item, handleHardCodedFormData, autoSubmitToEloqua } = this.props;
        const argsForDerivation = { domain, vertical, page: "resources" };
        const directValues = {
            leadSourceMostRecent1: item.data.lead_source || "Collateral Request",
            importSourceMostRecent1: item.data.title,
            lastAccessedAssetID1: item.data.asset_id,
            assetType: item.data.asset_type
        };
        handleHardCodedFormData(argsForDerivation, directValues);
        autoSubmitToEloqua(vertical);
    };

    renderVideo = (content) => {
        const { hasSubmitted } = this.props;
        const { isGated } = this.state;
        const isYoutube = content.media_url && /youtube/.test(content.media_url);
        // turn off autoplay if item is gated
        const isGateActive = (!isGated && !hasSubmitted) || false;
        const youtubeUrl =
            isGateActive && isYoutube ? content.media_url.replace("autoplay=1", "autoplay=0") : content.media_url;
        const youtube = (
            <iframe
                title={content.title}
                className="content__youtube"
                src={youtubeUrl}
                frameBorder="0"
                allowFullScreen
            />
        );
        const video = <video controls className="content__youtube" src={content.media_url} autoPlay={!isGated} />;
        return (
            <div className="media__container">
                {this.renderGate()}
                {isYoutube ? youtube : video}
            </div>
        );
    };

    renderFlipOrBtn = (content, downloadPDF) => {
        const { isMobile } = this.state;
        if (isMobile) {
            return (
                <div className="content__flipbook-btnWrapper">
                    <a href={content.media_url} download title={downloadPDF} className="btn btn-expand">
                        {downloadPDF}
                    </a>
                </div>
            );
        }
        return (
            <object aria-label={content.title} className="content__flipbook" data={content.media_url}>
                <iframe
                    aria-label={content.title}
                    title={content.title}
                    className="content__flipbook content__flipbook-iframe"
                    src={content.media_url}
                    frameBorder="0"
                    allowFullScreen
                >
                    <p>
                        Your browser does not support PDFs.{" "}
                        <a href={content.media_url} download title="Download the PDF">
                            Download the PDF
                        </a>
                        .
                    </p>
                </iframe>
            </object>
        );
    };

    renderFlipbook = (content, downloadPDF) => {
        const { isMobile } = this.state;
        const containerBackground = isMobile ? "none" : "url(../../static/blue-spinner.gif) center center no-repeat";
        if (content.media_url && !/youtube/.test(content.media_url)) {
            return (
                <>
                    <div
                        className="media__container media__container-flipbook"
                        style={{ background: containerBackground }}
                    >
                        {this.renderGate()}
                        {this.renderFlipOrBtn(content, downloadPDF)}
                    </div>
                </>
            );
        }
        return null;
    };

    renderGate = () => {
        const { item, hasSubmitted, domain, vertical, copyData } = this.props;
        const { isGated } = this.state;
        const isGateActive = (isGated && !hasSubmitted) || false;
        const assetType = item.data ? getAction(copyData, item.data.asset_type, "") : "";
        const submitText = assetType || copyData.form_submit;
        if (isGateActive) {
            return (
                <>
                    <div className="content__contact">
                        <h2>
                            {copyData.almost_there}
                            <span className="content__lock">
                                <svg viewBox="0 0 32 48" xmlns="http://www.w3.org/2000/svg">
                                    <path d="m29.3873418 18.7518658h-1.4154532v-5.680577c-.000162-7.20761575-5.3706532-13.0712888-11.9722127-13.0712888-6.60123539 0-11.97172653 5.86367305-11.97172653 13.0712888v5.680577h-1.41529114c-1.44299747 0-2.61265823 1.2770728-2.61265823 2.8525833v23.5429675c0 1.5755106 1.16966076 2.8525834 2.61265823 2.8525834h26.77468357c1.4429974 0 2.6126582-1.2770728 2.6126582-2.8525834v-23.5429675c0-1.5755105-1.1698228-2.8525833-2.6126582-2.8525833zm-10.8490532 14.9015416v4.675937c0 1.5305768-1.1364456 2.7713842-2.5382886 2.7713842s-2.5382886-1.2408074-2.5382886-2.7713842v-4.675937c-.953519-.8206594-1.5664608-2.0920713-1.5664608-3.5205743 0-2.4752463 1.8376912-4.4816959 4.1047494-4.4816959s4.1047494 2.0064496 4.1047494 4.4816959c0 1.428503-.6129418 2.6999149-1.5664608 3.5205743zm2.9524253-15.1668982h-10.9817519v-5.4152204c0-3.30581243 2.4631089-5.99511303 5.490876-5.99511303s5.4910379 2.6893006 5.4910379 5.99511303v5.4152204z" />
                                </svg>
                            </span>
                        </h2>
                        <GateForm
                            domain={domain}
                            vertical={vertical}
                            page="resources"
                            leadSourceMostRecent1={item.data.lead_source || "Collateral Request"}
                            lastAccessedAssetID1={item.data.asset_id}
                            assetType={item.data.asset_type}
                            copyData={copyData}
                            importSourceMostRecent1={item.data.title}
                            submitText={submitText}
                        />
                    </div>
                    <div className="content__gate content__gate--active" />
                </>
            );
        }
        return null;
    };

    render() {
        const { item, copyData } = this.props;
        const content = item.data;
        const { asset_type, media_url } = content;
        const isVideo = asset_type === "video" || asset_type === "webinar";
        const isFlipbook = !isVideo && media_url;
        return (
            <div className="content__container" data-uberflip={content.uberflip_url}>
                <ContentBackground />
                <div className="content__card">
                    {isVideo && this.renderVideo(content)}
                    <h1>{content.title}</h1>
                    {/* eslint-disable-next-line react/no-danger */}
                    <div className="content__content" dangerouslySetInnerHTML={createMarkup(content.content)} />
                    {isFlipbook && this.renderFlipbook(content, copyData.download_pdf)}
                </div>
            </div>
        );
    }
}

ContentTemplate.propTypes = {
    domain: domainType.isRequired,
    vertical: verticalType.isRequired
};

const mapStateToProps = (state) => ({
    // TODO: Move these to selectors
    hasSubmitted: state.formSubmitted
});

const ContentTemplateConnected = connect(mapStateToProps, {
    autoSubmitToEloqua: eloquaActions.autoSubmitToEloqua,
    handleHardCodedFormData: formEntryActions.handleHardCodedFormData
})(ContentTemplate);

export default ContentTemplateConnected;
